export default "__VITE_ASSET__CsE4wOkP__"